<template>
  <div class="single-product-gallery-1">


    <swiper :options="swiperOptions" :modules="modules" :zoom="!galleryFullSlider"
            class="gallery-top"
            @swiper="setMainSwiper"
            :data-toggle="galleryFullSlider ? 'modal' : ''" data-target="#gallery-modal"
            :thumbs="{ swiper: thumbsSwiper }" ref="swiperTop">

      <template v-if="isProductReady(product)">
        <swiper-slide v-for="img in productImages(product)" :key="img.id">
          <div class="swiper-zoom-container">
            <single-product-gallery-slide1 class="single-product-slider-2-gallery-item" :product="product"
                                           :file="img" :video-controls="true"/>
          </div>
        </swiper-slide>
      </template>
      <div
          class="swiper-pagination swiper-pagination-bullets"
          slot="pagination"
      ></div>
    </swiper>
    <span class="single-product-zoom-note">
                    <i class="bi product-main-slider-notation bi-info-circle-fill"></i>
                     <span v-t="`product.single.zoom_note`"></span>
                  </span>
    <swiper @swiper="setThumbsSwiper"
            :freeMode="true"
            :breakpoints="swiperThumbOptions.breakpoints"
            :watchSlidesProgress="true"
            :modules="modules"
            :navigation="true"
            class="mySwiper2 gallery-thumbs">

      <template v-if="isProductReady(product)">
        <swiper-slide v-for="img in productImages(product)" :key="img.id">
          <single-product-gallery-slide1 :product="product" :file="img"/>
        </swiper-slide>
      </template>

    </swiper>

    <teleport to="body">
      <div class="modal fade" id="gallery-modal"
           tabindex="-1" aria-labelledby="exampleModalLabel"
           aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">

              <swiper :options="swiperOptions" :modules="modules" :zoom="true"
                      :navigation="true"
                      class="gallery-top"
                      :thumbs="{ swiper: thumbsSwiper }" ref="swiperTop">
                <template v-if="isProductReady(product)">
                  <swiper-slide v-for="img in productImages(product)" :key="img.id">
                    <div class="swiper-zoom-container">
                      <single-product-gallery-slide1 class="single-product-slider-2-gallery-item" :product="product"
                                                     :file="img" :video-controls="true"/>
                    </div>
                  </swiper-slide>
                </template>
                <div
                    class="swiper-pagination swiper-pagination-bullets"
                    slot="pagination"
                ></div>
              </swiper>
              <span class="single-product-zoom-note float-right">
                             <i class="bi product-main-slider-notation bi-info-circle-fill"></i>
                              <span v-t="`product.single.gallery_modal_zoom_note`"></span>
                            </span>

            </div>
          </div>
        </div>
      </div>
    </teleport>

  </div>
</template>


<script>
import {Swiper, SwiperSlide} from "swiper/vue";
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import 'swiper/css/effect-fade';
import "swiper/css/free-mode"
import "swiper/css/thumbs"
import {Zoom, Navigation, Thumbs} from "swiper";
import SingleProductGallerySlide1 from "../Components/SingleProductGallerySlide/SingleProductGallerySlide1.vue";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";


export default {
  name: "SingleProductGallery1",
  components: {
    SingleProductGallerySlide1,
    Swiper,
    SwiperSlide,
  },
  props: {
    product: {},
    galleryFullSlider: {default: false}
  },
  setup() {
    return {modules: [Zoom, Navigation, Thumbs]}
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        effect: "fade",
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },

      },
      swiperThumbOptions: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20
          },
          500: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20
          },
          600: {
            slidesPerView: 3,
            slidesPerGroup: 2,
            spaceBetween: 20
          },
          765: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20
          },
          980: {
            slidesPerView: 4,
            slidesPerGroup: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 6,
            slidesPerGroup: 5,
            spaceBetween: 20
          }
        }
      },
      thumbsSwiper: null,
      mainSwiper:null,
    };
  },
  methods: {
    setThumbsSwiper(swiper) {
      this.thumbsSwiper = swiper;
    },
    setMainSwiper(swiper) {
      this.mainSwiper = swiper;
    },
    handleKeyPress(event) {
      if (event.key === 'ArrowLeft') {
        this.mainSwiper.slideNext();
      } else if (event.key === 'ArrowRight') {
        this.mainSwiper.slidePrev();
      }
    },
    productImages(product) {
      let result = []
      if (product.length == 0) return result

      result.push({
        id: `image_${generateHash()}`,
        file: product.thumbnail
      })

      if (product.images.length == 0) return result

      product.images.forEach(item => {
        result.push(item)
      })

      return result
    },
    isProductReady(product) {
      return Object.keys(product).length > 0
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeyPress);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyPress);
  },
}
</script>


<style scoped>
@media only screen and (max-width: 500px) {
  .single-product-gallery-1 {
    height: auto !important;
  }
}

.single-product-gallery-1 {
  height: 750px
}

.img-slider {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 5px;
}

.gallery-thumbs-img-slider {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  background: white;
  border-radius: 15px !important;
}

.gallery-top {
  height: 80% !important;
  width: 100%;
  border-radius: 15px !important;
  padding: 0 !important;
}


.gallery-thumbs {
  height: 20% !important;
  box-sizing: border-box;
  padding: 10px 0;
}

.gallery-thumbs .swiper-slide {
  width: 25%;
  height: 100%;
}


</style>